import { Button, Checkbox, Form, Input, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { OrganizationConfigProps } from "js/components/Organization/types";
import { useSelector } from "react-redux";

const { Title } = Typography;

const General: React.FC<OrganizationConfigProps> = ({
  data,
  onFinish,
  loading,
}) => {
  const [form] = Form.useForm();
  const { membershipData } = useSelector((state) => state.entities.membership);
  const { organizationData } = useSelector(
    (state) => state.entities.organization,
  );
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const hasTenantModule = organizationData?.modules?.includes("tenant");
  const hasCreditHistModule =
    organizationData?.modules?.includes("credit_history");
  const hideQuotas = hasTenantModule && !hasCreditHistModule;

  const modulesName: {
    [key: string]: string;
  } = {
    credit_history: "Historial Crediticio",
    tenant: "Inquilino",
  };

  useEffect(() => {
    const hasTenantModule = organizationData?.modules.includes("tenant");
    if (hasTenantModule) {
      if (membershipData && !membershipData?.permissions.reportDistributor) {
        setIsCheckboxDisabled(true);
      }
    }
  }, [organizationData, membershipData]);

  return (
    <>
      <div>
        <Title level={3}>General</Title>
      </div>
      <div>
        <Title level={5}>Módulos Contratados:</Title>
        <ul>{data?.modules.map((value) => <li>{modulesName[value]}</li>)}</ul>
      </div>
      <div style={{ marginTop: 30 }}>
        <Title level={5}>Fuente de Información: {data?.sic_source}</Title>
      </div>
      <div style={{ marginTop: 30 }}>
        {data && (
          <Form
            form={form}
            onFinish={onFinish}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{
              name: data.name,
              visualize_members: data.visualize_members,
              visualize_quotes: data.visualize_quotes,
              send_multireport_end_user: data.send_multireport_end_user,
              use_quotes: data.use_quotes,
            }}
          >
            <Form.Item
              name="name"
              label="Nombre de la Organización:"
              style={{ width: "40%" }}
            >
              <Input
                placeholder="Nombre de la Organización"
                prefix={<Icon icon="octicon:organization-24" />}
                onInput={(e) => {
                  e.currentTarget.value = e.currentTarget.value.toUpperCase();
                }}
              />
            </Form.Item>

            {!hideQuotas && (
              <Form.Item name="use_quotes" valuePropName="checked">
                <Checkbox disabled={isCheckboxDisabled}>
                  Usar cuotas de la organización.
                </Checkbox>
              </Form.Item>
            )}

            <Form.Item name="visualize_members" valuePropName="checked">
              <Checkbox>
                Permitir a los asesores ver a los demás asesores de la
                organización.
              </Checkbox>
            </Form.Item>

            {!hideQuotas && (
              <Form.Item name="visualize_quotes" valuePropName="checked">
                <Checkbox>
                  Permitir a los asesores ver las cuotas de la organización.
                </Checkbox>
              </Form.Item>
            )}

            <Form.Item name="send_multireport_end_user" valuePropName="checked">
              <Checkbox>Enviar multireporte al usuario final.</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? "Guardando" : "Guardar"}
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </>
  );
};

export default General;
